__turbopack_context__.v({
  "className": "PC_o7G_className",
  "variable": "PC_o7G_variable",
});
